import React, { ElementType } from 'react';
import { ListIcon as ChakraListIcon } from '@chakra-ui/react';

interface Props {
  as?: ElementType;
}

export const ListIcon = ({ ...props }: Props): JSX.Element => {
  return <ChakraListIcon {...props} />;
};
export type { Props as ListIconProps };
